import './style.scss'
import { useState } from "react"
import { 
    AbsoluteContainer, AppSpan, CustomContainer, 
    FlexRow, GridContainer, ScreenContainer, ScreenTitle 
} from "src/style"
import utility from "src/utils/utility"
import { Privacy, Profile } from 'src/component'

export const Settings = () => {
    const [navPosition, setNavPosition] = useState(0)
    
    return (
        <ScreenContainer padding='3'>
            <ScreenTitle 
                color='#333333' 
                textSize='2.4' 
                fontWeight='700'
                bottomMargin="4"
            >
                Settings
            </ScreenTitle>

            <GridContainer
                className='scrollable-container toggle-border-bottom'
                height="3.6" width='26'
            >
                <AbsoluteContainer 
                    width={navPosition === 0 ? '12' : '15'} 
                    top="0" left={`${navPosition}`}
                >
                    <CustomContainer 
                        bgColor="#F0ECFF" height="3.6" 
                        borderBottomColor='#5627FF' borderWidth='4.5'
                    />
                </AbsoluteContainer>
                <FlexRow
                    alignItems='flex-start' gap="1"
                    style={{zIndex: '2'}}
                >
                    <GridContainer 
                        width='11.6'
                        hoverBgColor={navPosition === 0 ? '' : '#F0ECFF'}
                        onClick={() => setNavPosition(0)}
                        className='toggled-item'
                    >
                        <AppSpan  
                            cursor="pointer"
                            fontWeight={navPosition === 0 ? "700" : "400"}
                            color={navPosition === 0 ? "#181D27" : "#828282"}
                        >
                            Profile
                        </AppSpan>
                    </GridContainer>
                    <GridContainer 
                        width='12'
                        hoverBgColor={navPosition === 12.6 ? '' : '#F0ECFF'}
                        onClick={() => setNavPosition(12.6)}
                        className='toggled-item'
                    >
                        <AppSpan 
                            cursor="pointer"
                            fontWeight={navPosition === 12.6 ? "700" : "400"}
                            color={navPosition === 12.6 ? "#181D27" : "#828282"}
                        >
                            Privacy
                        </AppSpan>
                    </GridContainer>
                </FlexRow>
            </GridContainer>
            { navPosition === 0 ?
                <Profile />
                : <Privacy />
            }
        </ScreenContainer>
    )
}

export default utility.routeData('settings', 'Settings', <Settings/>)